import { HttpClient } from '@angular/common/http';
import { ToasterService } from 'angular2-toaster';
import { ConfigService } from './config.service';
import { Injectable } from '@angular/core';

import { Subject } from 'rxjs/Subject';

import * as awsIot from 'aws-iot-device-sdk';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class IotService {
  private mapOfShadow$ = new Map<string, Subject<any>>();
  private currentTimeout = null;

  constructor(private config: ConfigService, private toasterService: ToasterService, private httpClient: HttpClient) {}

  initThingShadow(shadowName) {
    if (!this.mapOfShadow$.get(shadowName)) {
      this.mapOfShadow$.set(shadowName, new Subject<any>());
    }

    const component = this;
    const clientId = this.config.getConfig('appName') + '-' + Math.floor(Math.random() * 100000 + 1);

    const thingShadow = awsIot.thingShadow({
      protocol: this.config.getConfig('protocol'),
      clientId: clientId,
      region: this.config.getConfig('region'),
      debug: this.config.getConfig('debug'),
      accessKeyId: localStorage.getItem('accessKeyId'),
      secretKey: localStorage.getItem('secretKey'),
      sessionToken: localStorage.getItem('sessionToken'),
      host: this.config.getConfig('iotEndpoint') // override the default even though we are still using version 1.x.x of the aws-iot-device-sdk
    });

    thingShadow.on('connect', function() {
      // on connect - register the device, then add listeners, then perform a get operation 3s later
      thingShadow.register(
        shadowName,
        {
          persistentSubscribe: true,
          ignoreDeltas: true
        },
        function() {
          // console.log('registered iot device: ', shadowName);
        }
      );

      thingShadow.on('status', function(thingName, stat, clientToken, stateObject) {
        // console.log('received ' + stat + ' on ' + thingName);
        component.mapOfShadow$.get(shadowName).next(stateObject);
      });

      thingShadow.on('delta', function(thingName, stateObject) {
        // console.log('received delta on ' + thingName);
        component.mapOfShadow$.get(shadowName).next(stateObject);
      });

      thingShadow.on('foreignStateChange', function(thingName, stat, stateObject) {
        console.log('received foreign state change ' + stat + 'on ' + thingName);
        component.mapOfShadow$.get(shadowName).next(stateObject);
      });

      thingShadow.on('timeout', function(thingName, clientToken) {
        console.log('received timeout on ' + thingName + ' with token: ' + clientToken);
      });
    });

    thingShadow.on('reconnect', function() {
      console.log('Reconnecting node shadow', shadowName);
    });

    setTimeout(function() {
      const opClientTokenControl = thingShadow.get(shadowName);
      if (opClientTokenControl === null) {
        console.log('Getting shadow still in progress...');
      }
    }, 3000);

    return thingShadow;
  }

  getThingUpdates(shadowId: string): Observable<any> {
    try {
      const observable = this.mapOfShadow$.get(shadowId).asObservable();
      return observable;
    } catch (error) {
      console.warn(`Error getting update observable for ${JSON.stringify(shadowId, null, 2)}` + error);
      throw error;
    }
  }

  public unregisterShadow(shadow, name) {
    shadow.unregister(name);
  }

  updateThing(thingShadow, desiredStateObject, thingName) {
    if (!desiredStateObject) {
      console.error('No desired state. Aborting update.');
      return;
    }
    const desiredShadow = {
      state: { desired: desiredStateObject }
    };
    // perform update, which either returns a token
    // if non-null, means completed, will be sent via 'status' event
    // if null, means another operation is updating shadow, wait till it finishes
    const clientToken = thingShadow.update(thingName, desiredShadow);
    // TODO: can refactor to check thingShadow[thingName].pending instead
    // queue auto retry, unless another retry already in queue

    console.warn('Client token is now ', clientToken);

    if (clientToken === null) {
      if (this.currentTimeout === null) {
        console.log('Another operation in progress, queuing retry...');
        this.currentTimeout = setTimeout(() => {
          this.currentTimeout = null;
          this.updateThing(thingShadow, desiredStateObject, thingName);
        }, 10000 * 2); // AWS IOT default timeout is 10000 ms
      } else {
        // tell user to re-trigger update
        this.toasterService.pop({
          type: `error`,
          title: `Previous updates have not completed`,
          body: `Please retry in a few seconds`
        });
        console.error('Shadow operation still in progress.');
      }
    }
  }

  auditUpdateACControls(reportedStateObject) {
    const baseUrl = this.config.getIotUrl();
    const url = `${baseUrl}/aircon/update-controls`;
    return this.httpClient.post(url, reportedStateObject).toPromise();
  }
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/core/iot.service.ts